/**
 * System which covers all heating in system
 * - used in Olsztyn BR systems
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import i18n from '../../../../i18n'

import Konva from 'konva'

export default class HeatingSystem extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'heatingSystem',
        x: 0,
        y: 0,
        width: 160,
        height: 30,
        strokeWidth: 0.5,
        fill: 'white',
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'heatingSystemCorrectionValue',
        x: 5,
        y: 10,
        text: '',
        width: 150,
        fontSize: 13,
        align: 'center',
        fill: 'black'
      })
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // online
    if (this.online) {
      this.modifyShape('zone', 'fill', Color.sigBack)
    }
    const correctionValue = status.setPoint || status.correction
    const correctionText = status.setPoint ? i18n.t('visuals.set-point-value') : i18n.t('visuals.correction-value')

    this.modifyShape('heatingSystemCorrectionValue', 'text', `${correctionText} ${correctionValue ? parseFloat(correctionValue).toFixed(1) : ''} °C`)
  }
}
